angular.module('shared').factory('PageSettingsService', ["$rootScope", "$stateParams", "$state", "$http", "$q", "CwStorage", "flash", "MasqueradingService", function($rootScope, $stateParams, $state, $http, $q, CwStorage, flash, MasqueradingService) {
  var getFromStorage, isRequirementAvailable, loadSettings;
  getFromStorage = function(key) {
    return JSON.parse(CwStorage.getItem(key)) || {};
  };
  loadSettings = function(page) {
    var deferred, url;
    deferred = $q.defer();
    if (MasqueradingService.isMasquerading()) {
      deferred.resolve(getFromStorage(`${page}_page_settings`));
    } else {
      url = `/gyms/${$stateParams.gymId}/page_settings?filters[page]=${page}`;
      $http.get(url).then(function(response) {
        var ref;
        return deferred.resolve(((ref = response.data.collection[0]) != null ? ref.settings : void 0) || {});
      });
    }
    return deferred.promise;
  };
  isRequirementAvailable = function(requirement) {
    var gym;
    gym = $rootScope.gym;
    if (requirement === 'autopayments') {
      return gym.payment_system;
    }
    if (requirement === 'mobile_app') {
      return gym.mobile_app_enabled;
    }
    if (requirement === 'martial_arts') {
      return gym.is_martial_arts;
    }
    return true;
  };
  return {
    settings: {},
    preload: _.debounce(function(page, params = {}) {
      var ref;
      if ((ref = $state.current.name) === 'gym.setup' || ref === 'gym.subscriptions' || ref === 'gym.subscription.tab') {
        return;
      }
      return this.load(page, params);
    }, 500),
    loadMeta: function(page) {
      var deferred, ref, url;
      deferred = $q.defer();
      if ((ref = this.settings[page]) != null ? ref.available_columns : void 0) {
        deferred.resolve({
          available_columns: this.settings[page].available_columns
        });
      } else {
        url = `/gyms/${$stateParams.gymId}/page_settings/meta?page=${page}`;
        $http.get(url).then(function(response) {
          return deferred.resolve(response.data);
        }, function(response) {
          return deferred.reject(response);
        });
      }
      return deferred.promise;
    },
    load: function(page, params) {
      var deferred, loadMetaPromise, promises;
      deferred = $q.defer();
      loadMetaPromise = params.withMeta ? this.loadMeta(page) : window.Promise.resolve(null);
      promises = [loadMetaPromise, loadSettings(page)];
      $q.all(promises).then((result) => {
        var columns, setting;
        setting = result[1];
        if (params.withMeta) {
          setting.available_columns = result[0].available_columns;
          if (setting.available_columns) {
            columns = setting.available_columns.map(function(column) {
              column.hidden = !_.every(column.requirements, isRequirementAvailable);
              column.display = (setting != null ? setting.display_column_names : void 0) ? (setting != null ? setting.display_column_names.indexOf(column.name) : void 0) >= 0 : column.display_default;
              return column;
            });
            setting.columns = _.sortBy(columns, function(column, index) {
              var newIndex;
              if (setting != null ? setting.display_column_names : void 0) {
                newIndex = setting != null ? setting.display_column_names.indexOf(column.name) : void 0;
                if (newIndex >= 0) {
                  return newIndex;
                } else {
                  return setting.display_column_names.length;
                }
              } else {
                return index;
              }
            });
          }
        }
        this.settings[page] = setting;
        $rootScope.$emit('page_settings:updated');
        return deferred.resolve(setting);
      }, function() {
        flash.error = "There was an error processing the request.";
        return deferred.reject();
      });
      return deferred.promise;
    },
    getSettings: function(page) {
      var deferred;
      deferred = $q.defer();
      if (this.settings[page]) {
        deferred.resolve(this.settings[page]);
      } else {
        loadSettings(page).then((settings) => {
          this.settings[page] = settings;
          return deferred.resolve(settings);
        }, function() {
          deferred.reject();
          return flash.error = "There was an error processing the request.";
        });
      }
      return deferred.promise;
    },
    saveSettings: function(page, settings, opts) {
      var data, deferred, gym, key, url;
      deferred = $q.defer();
      data = {
        page_setting: {
          page: page,
          settings: settings
        }
      };
      if (MasqueradingService.isMasquerading()) {
        key = `${page}_page_settings`;
        data = angular.extend({}, getFromStorage(key), settings);
        this.settings[page] = data;
        CwStorage.setItem(key, JSON.stringify(data));
        deferred.resolve(data);
      } else {
        gym = $rootScope.gym;
        url = `/gyms/${gym.id}/page_settings/upsert`;
        $http.post(url, data).then((response) => {
          var params;
          if (opts != null ? opts.skipReload : void 0) {
            this.settings[page] = angular.extend(this.settings[page], settings);
            return deferred.resolve(this.settings[page]);
          } else {
            params = {
              withMeta: !!this.settings[page].available_columns
            };
            return this.load(page, params).then(function(response) {
              return deferred.resolve(response);
            }, function() {
              return deferred.reject();
            });
          }
        }, function(response) {
          return flash.error = "There was an error processing the request.";
        });
      }
      return deferred.promise;
    }
  };
}]);
